// Establish Phoenix Socket and LiveView configuration.
// @ts-ignore
import { Socket } from 'phoenix'

// @ts-ignore
import { LiveSocket } from 'phoenix_live_view'
import topbar from '../vendor/topbar'
import { CloudflareTurnstileHook } from './hooks/CloudflareTurnstileHook'

// TODO(kacper): create separate files for admin hooks
import { CodeMirrorEditor } from './hooks/CodeMirrorEditor'
import { ImageForm } from './hooks/ImageForm'
import { CollectionImageForm } from './hooks/CollectionImageForm'
import { ImageUploader } from './uploaders/ImageUploader'
import { DndContainer } from './hooks/DndContainer'
import { AdminLocationImageMapHook } from './hooks/AdminLocationImageMapHook'
import { AdminVeloFriendlyMapHook } from './hooks/AdminVeloFriendlyMapHook'
import { AdminPlaceMapHook } from './hooks/AdminPlaceMapHook'
import { AdminTwoLineMapHook } from './hooks/AdminTwoLineMapHook'
import { BulkEditOpenerHook } from './hooks/BulkEditOpenerHook'
import { MaintainHeightHook } from './hooks/MaintainHeightHook'
import { AdminChartHook } from './hooks/AdminChartHook'
import { SortableListHook } from './hooks/SortableListHook'
import { UserVeloFriendlyMapHook } from './hooks/UserVeloFriendlyMapHook'
import { PrivacyPlaceMapHook } from './hooks/PrivacyPlaceMapHook'
import { UserVeloFriendlyPhotoForm } from './hooks/UserVeloFriendlyPhotoForm'
import { HistoryUpload } from './hooks/HistoryUploadHook'
import { listenForScrollIntoView } from './lib/scrollIntoView'

let csrfToken = document?.querySelector("meta[name='csrf-token']")?.getAttribute('content')
let liveSocket = new LiveSocket('/live', Socket, {
  longPollFallbackMs: 2500,
  params: { _csrf_token: csrfToken },
  hooks: {
    CloudflareTurnstileHook,
    CodeMirrorEditor,
    ImageForm,
    CollectionImageForm,
    DndContainer,
    AdminLocationImageMapHook,
    AdminVeloFriendlyMapHook,
    AdminPlaceMapHook,
    AdminTwoLineMapHook,
    BulkEditOpenerHook,
    MaintainHeightHook,
    AdminChartHook,
    SortableListHook,
    UserVeloFriendlyMapHook,
    PrivacyPlaceMapHook,
    UserVeloFriendlyPhotoForm,
    HistoryUpload,
  },
  uploaders: { ImageUploader },
})

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: '#29d' }, shadowColor: 'rgba(0, 0, 0, .3)' })
window.addEventListener('phx:page-loading-start', (_info) => topbar.show(300))
window.addEventListener('phx:page-loading-stop', (_info) => topbar.hide())
listenForScrollIntoView()

// LiveView reloads every page restored from the back/forward cache, because a
// LiveView's server process doesn't survive it. Controller-rendered pages have
// none, so the reload only throws away the restored page and remounts React.
// Must be registered before liveSocket.connect(), which adds LiveView's listener.
function preventBfcacheReloadWithoutLiveView(event: PageTransitionEvent) {
  const hasLiveView = document.querySelector('[data-phx-session]') !== null
  if (!event.persisted || hasLiveView) {
    return
  }

  event.stopImmediatePropagation()
}

window.addEventListener('pageshow', preventBfcacheReloadWithoutLiveView, true)

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
// @ts-ignore
window.liveSocket = liveSocket
